import * as Flowbite from 'flowbite-react';
import { BaseInputProps } from '../types';
import { theme } from '../Text/theme';
import { isNaN } from 'lodash';

type NumberProps = BaseInputProps<number | ''> & {
    isDecimal?: boolean;
};

export const NumberInput = ({
    onChange = () => {},
    label,
    color = 'primary',
    isDecimal = false,
    ...props
}: NumberProps) => {
    return (
        <Flowbite.Label
            className="flex flex-col gap-2 font-normal"
            color={color}
        >
            {label && <span className="font-medium">{label}</span>}

            <Flowbite.TextInput
                {...props}
                theme={theme}
                color={color}
                type="number"
                inputMode={isDecimal ? 'decimal' : 'numeric'}
                pattern={isDecimal ? '[0-9]*\\.?[0-9]*' : '[0-9]*'}
                onChange={(e) => {
                    const { value } = e.target;
                    const number = isDecimal
                        ? parseFloat(value)
                        : parseInt(value, 10);

                    if (value === '') {
                        return onChange(value);
                    }

                    if (!isNaN(number)) {
                        return onChange(number);
                    }
                }}
            />
        </Flowbite.Label>
    );
};
